import React from 'react'
import { getAlignClass } from '../../../../helpers'

export const Description = ({ align, children }) => {
  const alignClass = getAlignClass(align)

  return <p className={`image-text__description ${alignClass}`}>{children}</p>
}
